var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.t(
            "health",
            "If you want, you can set your initial weight and a target for your weight. Do this in the settings in the sidebar. You will see right here how much you added or lost and what is left. Maybe you can be motivated this way.",
            {}
          )
        )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }